import React from "react";
import { inject, observer } from "mobx-react";
import { ProposalStore } from "../../stores/proposalStore";
import { CalculateStore } from "../../stores/calculateStore";
import Notification from "../sharedComponents/notification/notification";
import { ErrorMessages } from "../../helpers/errorMessage";
import { UiFlagsStore } from "../../stores/uiFlagsStore";
import { PolicyStore } from "../../stores/policyStore";
import { ClientStore } from "../../stores/clientStore";
import Header from "../sharedComponents/header/header";
import "./exceededProxies.scss";
import { RetrieveCalculationService } from "../../services/services/retrieveCalculationService";
import { PolicyService } from "../../services/services/policyService";

interface ExceededProxiesProps {
  proposalStore?: ProposalStore;
  calculateStore?: CalculateStore;
  uiFlagsStore?: UiFlagsStore;
  policyStore?: PolicyStore;
  clientStore?: ClientStore;
  retrieveCalculationService?: RetrieveCalculationService;
  policyService?: PolicyService;
}

@inject("proposalStore", "calculateStore", "uiFlagsStore", "policyStore", "clientStore", "retrieveCalculationService", "policyService")
@observer
export default class ExceededProxies extends React.Component<ExceededProxiesProps> {

  public render() {
    return (
      <div className="content exceeded-proxies">
        <div className="proposal-id">
          Numer wniosku: <span>{this.props.proposalStore!.proposalResponse.proposalId}</span>
        </div>

        {this.props.uiFlagsStore!.isDirect ? this.renderDirectContent() : this.renderAgentContent()}

        <div className="new-calc" onClick={() => this.newCalculation()}>
          Rozpocznij nową kalkulację
        </div>
      </div>
    );
  }

  private renderAgentContent() {
    return (
      <>
        <Header type="big"
          mainHeader="Przekroczone pełnomocnictwa"
        />
        <Notification type="http" message={ErrorMessages.response.exceededProxies} className={"info-message"} />
      </>
    );
  }

  private renderDirectContent() {
    return (
      <>
        <Header type="big"
          mainHeader="Dziękujemy za zainteresowanie ubezpieczeniem Bezpieczny Dom"
        />
        <div className="direct-content">
          Dziękujemy za zainteresowanie ubezpieczeniem Bezpieczny Dom, w celu sfinalizowania zakupu możesz
          skontaktować się z nami już teraz pod numerem telefonu <a href="tel:+48225345609">22 534 56 09</a> bądź
          z naszej strony najszybciej jak to możliwe będzie kontaktował się z Tobą nasz Doradca.
        </div>
      </>
    );
  }

  private newCalculation() {
    this.resetStoresAndService();
    this.props.uiFlagsStore!.goToNewCalculation();
  }

  private resetStoresAndService() {
    this.props.calculateStore!.resetStore();
    this.props.clientStore!.resetStore();
    this.props.proposalStore!.resetStore();
    this.props.policyStore!.resetStore();
    this.props.retrieveCalculationService!.reset();
    this.props.policyService!.reset();
  }
}
